import React, { memo } from 'react';

import { PAYMENT_ICONS } from './paymentIcons';

/**
 * SecureCheckoutRow — trust row for the listing header band (canvas 3a):
 * a mono "Secure checkout" label, a divider, the accepted card / wallet
 * acceptance marks, and a "Bank payment" (ACH) chip. Purely presentational.
 * Styling lives in cpg-stepper.css under `.cpg-band__secure*`.
 */
const SecureCheckoutRow = () => (
  <div className="cpg-band__secure">
    <span className="cpg-band__secure-label">Secure checkout</span>
    <span
      className="cpg-band__secure-sep"
      aria-hidden="true"
    />
    {PAYMENT_ICONS.map((icon) => (
      <img
        key={icon.alt}
        className="cpg-band__pay"
        src={icon.src}
        alt={icon.alt}
      />
    ))}
    <span className="cpg-band__secure-chip">
      <svg
        width="11"
        height="11"
        viewBox="0 0 12 12"
        fill="none"
        aria-hidden="true"
      >
        <path
          d="M1 4.5L6 1.5L11 4.5V5.5H1V4.5Z"
          fill="currentColor"
        />
        <rect x="2" y="6" width="1.6" height="3.5" fill="currentColor" />
        <rect x="5.2" y="6" width="1.6" height="3.5" fill="currentColor" />
        <rect x="8.4" y="6" width="1.6" height="3.5" fill="currentColor" />
        <rect x="1" y="10" width="10" height="1" fill="currentColor" />
      </svg>
      Bank payment
    </span>
  </div>
);

export default memo(SecureCheckoutRow);
